module.exports = __webpack_public_path__ + "img/Daftar-Active.ceb39b87.svg";